import { AppModule, BootParams } from "@10x/coreapp/AppModule";
import { registerRoutes } from "./web/Routes";
import { IRVContext } from "./RVContext";
import { registerPropertyService } from "./PropertyServices";
import { registerAppService } from "./AppServices";
import { RVReducer } from "./RVReducer";
import { registerMyRequestsService } from "./MyRequestsServices";

class BaseRVModule implements AppModule {
	registerModule( bootParams: BootParams ): void {
		registerRoutes( bootParams.navigationService );
		registerPropertyService( bootParams.propertyService );
		registerAppService( bootParams.appService );
		registerMyRequestsService( bootParams.myRequestsService );
		bootParams.storeService.registerReducer( "RValuation", RVReducer );
	}
}

export default BaseRVModule;


declare module "@10x/coreapp" {

	interface AppReducer {
		RValuation: IRVContext,
	}
}
